import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { FileText, Plus, Calendar, User } from "lucide-react";

export function CustomerServiceReports({ reports, customerId }) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle>Serviceberichte</CardTitle>
          <CardDescription>Durchgeführte Arbeiten</CardDescription>
        </div>
        <Button size="sm" asChild>
          <Link to={`/service-reports/new?customer=${customerId}`} data-testid="new-report-btn">
            <Plus className="w-4 h-4 mr-2" />
            Neuer Bericht
          </Link>
        </Button>
      </CardHeader>
      <CardContent>
        {reports.length > 0 ? (
          <div className="space-y-3">
            {reports.map((report) => (
              <Link
                key={report.id}
                to={`/service-reports/${report.id}`}
                className="flex items-center justify-between p-4 rounded-lg bg-muted/50 hover:bg-muted transition-colors"
              >
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                    <FileText className="w-5 h-5 text-primary" />
                  </div>
                  <div>
                    <p className="font-medium">{report.title}</p>
                    <div className="flex gap-3 text-sm text-muted-foreground">
                      <span className="flex items-center gap-1">
                        <Calendar className="w-3 h-3" />
                        {new Date(report.service_date).toLocaleDateString("de-DE")}
                      </span>
                      {report.technician_name && (
                        <span className="flex items-center gap-1">
                          <User className="w-3 h-3" />
                          {report.technician_name}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <Badge variant={report.signed_at ? "default" : "secondary"}>
                  {report.signed_at ? "Unterschrieben" : "Offen"}
                </Badge>
              </Link>
            ))}
          </div>
        ) : (
          <div className="empty-state py-8">
            <FileText className="w-12 h-12 text-muted-foreground/30" />
            <p className="text-muted-foreground mt-4">Keine Serviceberichte vorhanden</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
